import { Copy, MoreHorizontal } from "lucide-react";
import { useState } from "react";
import { DuplicateBookingDialog } from "@/bookings/DuplicateBookingDialog";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface BookingActionMenuProps {
  bookingId: string;
}

export function BookingActionMenu({ bookingId }: BookingActionMenuProps) {
  const [duplicateOpen, setDuplicateOpen] = useState(false);

  return (
    // React events bubble through portals, so this stops clicks in the menu and dialog from opening the row
    <div className="flex justify-center" onClick={(e) => e.stopPropagation()}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="h-8 w-8 p-0">
            <span className="sr-only">Open menu</span>
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => setDuplicateOpen(true)}>
            <Copy className="mr-2 h-4 w-4" />
            Duplicate
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <DuplicateBookingDialog bookingId={bookingId} open={duplicateOpen} onOpenChange={setDuplicateOpen} />
    </div>
  );
}
